import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AccountModel} from "../../angular/models/account.model";
import {AccountsAlerts} from "../../services/accounts-alerts.service";
import {$accountFactory} from "../../$account.factory";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {DepotsDialogService} from "../../../depots/services/depots-dialogs-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class ShipperAccountDepotsCtrl implements IController {

  account: AccountModel;
  loading: boolean;
  doReload: any;
  noDepots: any;
  canUpdate: any;

  private accountRef: any;

  constructor(private accountsAlerts: AccountsAlerts, private IAMPermissions, private $log, private $account: $accountFactory,
              private depotsDialogService: DepotsDialogService, private confirmDialogService: ConfirmDialogService, private bringozLoaderService: BringozLoaderService) {
  }

  $onInit() {
    this.loading = false;
    this.doReload = false;
    this.noDepots = [null];
    this.canUpdate = this.IAMPermissions.hasPermission('accounts.demand.update');

    this.accountRef = this.$account(this.account.id);
  };

  onAddDepot(event) {
    this.depotsDialogService.addDepots(event, this.account.depotIds)
      .then((selectedDepotsIds) => {
        if (!!selectedDepotsIds.length) {
          const accountCopy = angular.copy(this.account);
          if (!accountCopy.depotIds) {
            accountCopy.depotIds = [];
          }

          const newDepotIds = selectedDepotsIds
            .filter(depotId => !_.includes(accountCopy.depotIds, depotId));

          accountCopy.depotIds = accountCopy.depotIds.concat(newDepotIds);

          this.updateAccount(accountCopy);
        }
      })
      .catch((error) => {
      });
  }

  onRemoveDepot(depot, event) {
    this.confirmDialogService.confirm('Remove Depot', 'Do you wish to remove this depot?', event)
      .then(() => {
        const accountCopy = angular.copy(this.account);
        accountCopy.depotIds = _.without(this.account.depotIds, depot.id);

        if (!_.includes(accountCopy.depotIds, accountCopy.defaultDepotId)) {
          accountCopy.defaultDepotId = _.get(accountCopy.depotIds, '[0]');
        }

        this.updateAccount(accountCopy);
      })
  }

  onChangeToDefaultDepot(id, event) {
    this.confirmDialogService.confirm('Change Default Depot', 'Do you wish to select this depot as default?', event)
      .then(() => {
        const accountCopy = angular.copy(this.account);
        accountCopy.defaultDepotId = id;
        this.updateAccount(accountCopy)
      })
  }

  onReloadDepots() {
    this.doReload = false;
  }

  private updateAccount(account: AccountModel) {
    this.accountRef.$update(account)
      .then((updatedAccount) => {
        this.account = updatedAccount;
        this.accountsAlerts.demandAddToDepotSuccess();
      })
      .catch((error) => {
        if (error) {
          this.accountsAlerts.demandAddToDepotError();
          this.$log.error('Failed to update account @shipperAccountBranches@_updateAccount', error);
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('shipperAccountDepots', {
    bindings: {
      account: '<'
    },
    template: require('./shipper-account-depots.html').default,
    controller: ShipperAccountDepotsCtrl
  });
